const accordion = () => {
    const accordions = document.querySelectorAll('.accordion');
    if (!accordions.length) return;
    
    accordions.forEach((accordion) => {
        const items = accordion.querySelectorAll('.accordion-item');
        
        items.forEach((item, index) => {
            const title = item.querySelector('.accordion-item__title');
            const content = item.querySelector('.accordion-item__description');
            
            const contentId = `accordion-content-${index}`;
            const titleId = `accordion-title-${index}`;
            
            // Установка ARIA-атрибутов
            title.setAttribute('id', titleId);
            title.setAttribute('aria-expanded', item.classList.contains('show') ? 'true' : 'false');
            title.setAttribute('aria-controls', contentId);
            title.setAttribute('role', 'button');
            title.setAttribute('tabindex', '0');
            
            content.setAttribute('id', contentId);
            content.setAttribute('role', 'region');
            content.setAttribute('aria-labelledby', titleId);
            content.style.maxHeight = item.classList.contains('show') ? content.scrollHeight + 'px' : null;
            
            // Обработчик клика
            const toggleItem = () => {
                const isOpen = item.classList.contains('show');
                
                // Закрываем все элементы в этом аккордеоне
                items.forEach((otherItem) => {
                    const otherTitle = otherItem.querySelector('.accordion-item__title');
                    const otherContent = otherItem.querySelector('.accordion-item__description');
                    otherItem.classList.remove('show');
                    otherTitle.setAttribute('aria-expanded', 'false');
                    otherContent.style.maxHeight = null;
                });
                
                // Открываем текущий, если был закрыт
                if (!isOpen) {
                    item.classList.add('show');
                    title.setAttribute('aria-expanded', 'true');
                    content.style.maxHeight = content.scrollHeight + 'px';
                }
            };
            
            title.addEventListener('click', toggleItem);
            title.addEventListener('keydown', (e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    toggleItem();
                }
            });
        });
    });
};

document.addEventListener('DOMContentLoaded', accordion);
